export const EXCEPTION_TOOLTIP_COPY = (link: string) => (
  <div>
    Logistics issue delaying order fulfillment. Please see{' '}
    <a href={link} target="_blank">
      Order Items
    </a>{' '}
    tab for more information about this exception.
  </div>
);
